import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
    marginBottom: 0,
    padding: '4px 0',
    '@media (max-width: 767px)': {
      width: '100%',
    }
  },
  content: {
    whiteSpace: "nowrap",
  },
  refresh: {
    padding: 0,
  },
}));
